import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentNavigationService, NavigationResult } from '../../services/document-navigation.service';
import OrderSourceTransactionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/process/order/order-source-transaction/order-source-transaction.entity';

@Component({
  selector: 'app-document-navigation',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './document-navigation.component.html',
  styleUrls: ['./document-navigation.component.scss']
})
export class DocumentNavigationComponent {

  @Input() documentType!: string;
  @Input() documentSerial?: string;
  @Input() displayText?: string;
  @Input() showIcon: boolean = true;
  @Input() customClass?: string;
  @Input() sourceTransactions?: OrderSourceTransactionAttributes[]; // Para casos especiales como DT003 → DT002

  constructor(private documentNavigationService: DocumentNavigationService) {}

  /**
   * Obtiene la información de navegación del servicio
   */
  get navigationInfo(): NavigationResult {
    // Caso especial: DT003 con sourceTransactions
    if (this.documentType === 'DT003' && this.sourceTransactions?.length) {
      const hasOrders = this.sourceTransactions.some(t => t?.type?.code === 'DT002');
      return {
        canNavigate: hasOrders,
        tooltip: hasOrders ? 'Ir al pedido' : ''
      };
    }

    if (!this.documentSerial) {
      return {
        canNavigate: false,
        tooltip: ''
      };
    }

    return this.documentNavigationService.getNavigationInfo(this.documentType, this.documentSerial);
  }

  get isNavigable(): boolean {
    return this.navigationInfo.canNavigate;
  }

  get tooltipText(): string {
    return this.navigationInfo.tooltip;
  }

  get displayValue(): string {
    return this.displayText || this.documentSerial || '-';
  }

  navigateToDocument(): void {
    if (!this.isNavigable) {
      return;
    }

    // Caso especial: DT003 con sourceTransactions (Entregas → Pedidos)
    if (this.documentType === 'DT003' && this.sourceTransactions?.length) {
      this.documentNavigationService.navigateFromDeliveryToOrders(this.sourceTransactions);
      return;
    }

    // Navegación normal
    if (this.documentSerial) {
      this.documentNavigationService.navigateToDocument(this.documentType, this.documentSerial);
    }
  }

  getCssClasses(): string {
    const baseClasses = this.isNavigable
      ? 'underline cursor-pointer hover:text-blue-600 transition-colors'
      : 'cursor-not-allowed opacity-60';

    return this.customClass ? `${baseClasses} ${this.customClass}` : baseClasses;
  }
}